module.exports = __webpack_public_path__ + "img/4.b61ae0c0.png";